import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'riwayatjabatan'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const riwayatjabatanCreate = 'Kepegawaian/RiwayatJabatan/create/'
export const riwayatjabatanList = 'Kepegawaian/RiwayatJabatan/list/'
export const riwayatjabatanDetail = 'Kepegawaian/RiwayatJabatan/detail/'
export const riwayatjabatanUpdate = 'Kepegawaian/RiwayatJabatan/update/'
export const riwayatjabatanInactive = 'Kepegawaian/RiwayatJabatan/inactive/'
export const riwayatjabatanActive = 'Kepegawaian/RiwayatJabatan/active/'

export const masterPosition = 'Kepegawaian/Position/list/'
export const masterEchelon = 'Kepegawaian/Echelon/list/'
export const masterPositionStatus = 'Kepegawaian/PositionStatus/list/'
export const masterWorkUnit = 'Master/WorkUnit/list/'
export const masterSignatoryOfficial = 'Kepegawaian/SignatoryOfficial/list/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}